<template>
	<div style="display: inline">
		<v-chip
			v-if="chip"
			color="#f2f2f2"
			class="ml-1"
			small
			@click="downloadDocument(true)"
		>
			{{document.description}}
		</v-chip>
		<v-list-item
			v-else
			style="border: 1px solid #e0e0e0; border-radius: 5px"
		>
			<v-list-item-icon class="mr-3" @click="downloadDocument(true)" style="cursor: pointer">
				<v-icon>mdi-file-document-outline</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title style="overflow: hidden; width: 300px">
					<span class="font-weight-bold" style="cursor: pointer" @click="downloadDocument(document, true)">{{document.description}}</span>
					<span class="ml-2 text-caption">{{extension}}</span>
				</v-list-item-title>
				<v-list-item-subtitle>{{document.date}}</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-action>
				<v-row no-gutters align="center">
					<v-btn icon @click="downloadDocument(true)" :loading="loadingPreview">
						<v-icon color="primary">mdi-eye</v-icon>
					</v-btn>
					<v-btn icon @click="downloadDocument(false)" :loading="loadingDownload">
						<v-icon color="primary">mdi-download</v-icon>
					</v-btn>
					<v-btn icon @click="showEdit = true" :disabled="disabled || showEdit">
						<v-icon color="primary">mdi-pencil</v-icon>
					</v-btn>
					<v-btn icon @click="showDeleteAlert = true" :disabled="disabled || showDeleteAlert">
						<v-icon color="primary">delete</v-icon>
						<DeleteConfirmationDialog v-model="showDeleteAlert" item="document" @delete="deleteDocument" />
					</v-btn>
				</v-row>
			</v-list-item-action>
			<v-dialog v-model="showEdit" width="30%">
				<v-card>
					<v-card-title class="title primary--text mb-2 secondary">
						<translate>Edit Document</translate>
					</v-card-title>
					<v-card-text>
						<v-text-field
							class="mr-2"
							:rules="descriptionRules"
							:placeholder="$gettext('Description')"
							v-model="document.description"
							filled
							hide-details
						></v-text-field>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click="editDocument">
							<translate>Save</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-list-item>
		<v-dialog v-model="showPreview" width="70%" @click:outside="revokeURLs" scrollable>
			<v-card>
				<v-card-title v-if="extension == 'PDF'" class="title primary--text secondary">
					<v-row no-gutters align="center" justify="center">
						<v-btn x-small fab elevation="0" color="primary" @click="changePage(false)" :disabled="page == 1">
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
						<span class="mx-3 text-subtitle-1">{{page}} / {{numPages}}</span>
						<v-btn x-small fab elevation="0" color="primary" @click="changePage(true)" :disabled="page === numPages">
							<v-icon>mdi-arrow-right</v-icon>
						</v-btn>
					</v-row>
				</v-card-title>
				<v-card-text class="pa-4" ref="documentContainer">
					<PDF v-if="extension == 'PDF'" :src="pdfUrl" @num-pages="numPages = $event" :page="page" />
					<v-img v-else-if="extension == 'PNG' || extension == 'JPG' || extension == 'JPEG'" :src="imageUrl" max-height="600" contain />
					<p class="text-center text-h4 mt-3" v-else>Formato não suportado</p>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import PDF from 'vue-pdf'
import axios from "axios";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "DocumentItem",
  props: ["document", "chip", "disabled"],
  components: {
    PDF,
    DeleteConfirmationDialog
  },
  data: () => ({
    loadingPreview: false,
    loadingDownload: false,
    showEdit: false,
		showDeleteAlert: false,
		showPreview: false,
		pdfUrl: null,
    imageUrl: null,
		numPages: 1,
		page: 1
  }),
  computed: {
		descriptionRules() {
			return [v => !!v || this.$gettext("Description is required")];
    },
    extension() {
			let parts = this.document.blob.split('.');
			let extension = parts[1];
			return extension.toUpperCase();
    }
  },
  methods: {
		hexToBase64(str) {
			return btoa(String.fromCharCode.apply(null, str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")));
		},
    downloadDocument(preview) {
			let params = {}
      if(preview) {this.loadingPreview = true; params['preview'] = true;}
      else this.loadingDownload = true;
			axios
				.get("/download/" + this.document.blob, {params: params})
				.then(response => {
          if(preview) {
						console.log("PREVIEW");
						if(this.extension == 'PDF') this.pdfUrl = "data:application/pdf;base64," + response.data;
						//this.pdfUrl = window.URL.createObjectURL(new Blob(["data:application/pdf;base64," + response.data]));
            else if(this.extension == 'JPG' || this.extension == 'JPEG' || this.extension == 'PNG') this.imageUrl = "data:image/jpeg;base64," + response.data;
						//this.imageUrl = window.URL.createObjectURL(new Blob(["data:image/jpeg;base64," + this.hexToBase64(response.data)]));
						//console.log(this.hexToBase64(response.data));
						//this.imageUrl = window.URL.createObjectURL(new Blob(["data:image/jpeg;base64," + response.data]));
            this.showPreview = true;
            this.loadingPreview = false;
          } else {
						var link = document.createElement("a");
						link.href = "https://api.naltio.com/download/" + this.document.blob;
						//link.href = "http://127.0.0.1:5500/download/" + this.document.blob;
						link.target = "_self";
						document.body.appendChild(link);
            link.click();
            this.loadingDownload = false;
					}
				})
				.catch(error => {
          console.log(error);
          this.loadingPreview = false;
          this.loadingDownload = false;
				});
		},
		editDocument() {
			const formData = new FormData();
			formData.append("description", this.document.description);
			axios
				.post("/api/patient_detail/" + this.document.id + "/edit", formData)
				.then(response => {
					console.log(response.data);
					this.showEdit = false;
				})
				.catch(error => {
					console.log(error);
				});
		},
		deleteDocument() {
			axios
				.post("/api/patient_detail/" + this.document.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result === "deleted") {
            this.$emit('delete-document', this.document);
					}
					this.showDeleteAlert = false;
				})
				.catch(error => {
					console.log(error);
					this.showDeleteAlert = false;
				});
    },
		revokeURLs() {
			if(this.pdfUrl) {
				//URL.revokeObjectURL(this.pdfUrl);
				this.pdfUrl = null;
				this.page = 1;
				this.numPages = 1;
			}
			if(this.imageUrl) {
				//URL.revokeObjectURL(this.imageUrl);
				this.imageUrl = null;
      }
		},
		changePage(next) {
			if(next) this.page += 1;
			else this.page -= 1;
			this.$refs.documentContainer.scrollTop = 0;
		}
  }
}
</script>